class EducationDataCtrl {
  constructor($scope, $http, $compile, UtilsService) {

    var self = this;

    self.UtilsService = UtilsService;

    self.state = {
      languageRequired: false,
      schoolCountrySelected: '',
      schoolPlaceSelected: '',
      schoolNameDisabled: true,
      schoolNameSelected: '',
      thesisDefenseDate: false,
      university: false
    };

    self.data = {
      schoolCountry: [],
      schoolPlace: [],
      schoolTypes: [],
      schoolNames: [],
      mandatoryLanguages: [],
      optionalLanguages: [],
      levels: [],
      countries: [],
      secondarySchoolCertificate: [],
      diplomaStatus: [],
      years: []
    };

    self.sku = '';
    self.product = {};

    self.education = {
      schoolCountry: '',
      schoolPlace: '',
      schoolType: '',
      schoolName: '',
      diplomaStatus: '',
      diplomaIssueCountry: '',
      //date yyyy-MM-dd
      thesisDefenseDate: null,
      secondarySchoolCertificate: '',
      mandatoryLanguageLevels: [],
      optionalLanguageLevels: [],
      experience : [{
        companyDetails: {
          city: '',
          companyName: '',
          country: '',
          street: '',
          streetNumber: '',
          streetType: window.statics.defaultStreetType,
          zipCode: ''
        },
        jobTitle: '',
        stillWorking: '',
        workEndMonth: '',
        workEndYear: '',
        workStartMonth: '',
        workStartYear: ''
      }]
    };

    jQuery(document).ready(function() {
        // Get the ul that holds the collection of experience
        var $collectionHolder = jQuery('.experience');
        if (typeof $newLinkLi !== 'undefined') {
            $collectionHolder.append($compile($newLinkLi)($scope));
            $collectionHolder.data('index', $collectionHolder.find(':input').length);
        }
    });

    function addExperienceForm($collectionHolder, $newLinkLi) {
        var prototype = $collectionHolder.data('prototype');
        var index = $collectionHolder.data('index');
        var newForm = prototype.replace(/__name__/g, index);
        newForm = newForm.replace(/__counter__/g, $('.experience_container').length +1);
        $collectionHolder.data('index', index + 1);
        var $newFormLi = angular.element('<div></div>').append(newForm);

        setTimeout(() => {
            let mdOptionsToPrepare = document.querySelectorAll('md-option[data-value]');
            for(let i=0;i<mdOptionsToPrepare.length;i++)
            {
                if(mdOptionsToPrepare[i].querySelector('.md-text').innerHTML)
                    continue;
                mdOptionsToPrepare[i].querySelector('.md-text').innerHTML = mdOptionsToPrepare[i].getAttribute('data-value');
            }
        });
    }

    self.querySearchIn = function(query, data, arrKeyValue) {
      var results = query ? data.filter( createFilterFor(query, arrKeyValue) ) : data;
        return results;
    };

    function createFilterFor(query, arrKeyString) {
      return function filterFn(state) {
        var lowercaseQuery = angular.lowercase(query);
        return (angular.lowercase(state[arrKeyString]).indexOf(lowercaseQuery) >= 0);
      };

    }

    jQuery('body').on('click', '.remove-element', function(e) {
      e.preventDefault();
      jQuery(this).parent().remove();
      return false;
    });

    self.init = function () {
      self.data.schoolCountry = window.country;
      self.data.schoolPlace = window.schools;
      self.data.mandatoryLanguages = window.mandatoryLanguages;
      self.data.optionalLanguages = window.optionalLanguages;
      self.data.levels = window.levels;
      self.data.diplomaStatus = window.diplomaStatuses;
      self.sku = window.sku;
      self.price =  window.price;
      self.candidate = window.candidate;
      self.product = window.product;
      self.state.university = window.university;

      if (typeof window.education === 'object') {
        self.education = angular.merge(self.education, window.education);
        self.education.diplomaIssueCountry = window.education.diplomaIssueCountry;
        self.education.schoolType =  window.education.schoolType;
        self.changeSchoolNameDisabled();
        self.education.thesisDefenseDate = self.education.thesisDefenseDate ? self.education.thesisDefenseDate : null;
        if(self.education.diplomaStatus === 'Before defense' || self.education.diplomaStatus === 'Beforedefense' ){
            self.state.thesisDefenseDate = true;
        }

        self.loadSchoolsType();
      }

      if (Object.keys(self.data.mandatoryLanguages).length > 0) {
        if (self.education.mandatoryLanguageLevels.length === 0) {
            for (let i = 0; i < Object.keys(self.data.mandatoryLanguages).length; i++) {
                self.education.mandatoryLanguageLevels.push({ language: Object.keys(self.data.mandatoryLanguages)[i], level: null});
            }
        }
      }

      if (window.product.numberOfLanguages > 0) {
        self.state.languageRequired = true;
      }

      var year = new Date().getFullYear();
      self.data.years.push(year);
      for(var i=1;i<25;i++) {
          self.data.years.push(year - i);
      }
      self.loadALevelStatuses();
    };

    self.loadALevelStatuses = function () {
      $http({
        method: 'GET',
        url: self.UtilsService.getApiPath('api/dict/a-level-status?_format=json')
      }).then(function successCallback(response) {
        self.data.secondarySchoolCertificate = response.data;
      }, function errorCallback(response) {
        self.data.secondarySchoolCertificate = [];
      });
    };
    self.loadSchoolsType = function () {
      let endpoint;
      if(self.state.university === true) {
          endpoint = 'university-type';
      } else
          endpoint = 'school-type';

        $http({
          method: 'GET',
          url: self.UtilsService.getApiPath('api/dict/'+ endpoint +'?_format=json&city=' + self.education.schoolPlace)
      }).then(function successCallback(response) {
          self.data.schoolTypes = response.data;
          if (response.data.length <= 1) {
            self.loadSchoolsNames();
          }
      });

    };
    self.onSchoolPlaceChange = function () {
      if(self.education.schoolPlace && self.education.schoolType) {
        self.loadSchoolsNames();
      }
    };
    self.loadSchoolsNames = function () {
      let endpoint;
      if(self.state.university === true) {
          endpoint = 'university';
      } else
          endpoint = 'school';

      $http({
          method: 'GET',
          url: self.UtilsService.getApiPath('api/dict/'+endpoint+'?_format=json&city=' + self.education.schoolPlace + '&type=' + self.education.schoolType)
      }).then(function successCallback(response) {
          self.data.schoolNames = response.data;
          });
    };

     self.loadCountry = function () {
      if (self.data.countries.length === 0) {
        $http({
          method: 'GET',
          url: self.UtilsService.getApiPath('api/dict/country')
        }).then(function successCallback(response) {
          self.data.countries = response.data;
          return self.data.countries;
        }, function errorCallback(response) {

        });
      } else {
        return self.data.countries;
      }
    }();

    self.autocompletePostalCode = function(value) {
      if (/^\d\d$/.test(value)) {
        value = value + '-';
      }
      value = value.replace('--', '-');
      value = value.replace(/[^-0-9]/g, '');
      if (/^\d\d-\d\d\d.$/.test(value)) {
        value = /^\d\d-\d\d\d/.exec(value);
      }
      return value;
    };

    self.addressPostalCodeChange = function (index) {
      if (self.education.experience[index].companyDetails.country === 'Poland') {
          var zipCode = self.education.experience[index].companyDetails.zipCode;
          self.education.experience[index].companyDetails.zipCode = self.autocompletePostalCode(zipCode);
          if (!/^\d\d-\d\d\d$/.test(zipCode)) {
              return;
          }
          if (self.education.experience[index].companyDetails.city === '' || !self.education.experience[index].companyDetails.city) {
              $http({
                  method: 'GET',
                  url: self.UtilsService.getApiPath('api/dict/cityByPostalCode/' + self.education.experience[index].companyDetails.zipCode + '?_format=json')
              }).then(function success(response) {
                  if (response.data.length === 1) {
                      self.education.experience[index].companyDetails.city = response.data[0].city;
                  }
              }, function error() {

              });
          }
      }
    };

    self.diplomaStatusChange = function () {
        if(self.education.diplomaStatus === window.statics.beforeDefense) {
            self.state.thesisDefenseDate = true;
        } else {
            self.state.thesisDefenseDate = false;
        }
    };

      self.isFirstLevelOrLongCycle = function () {
        return self.product.isFirstLevel || self.isLongCycle;
    };

    self.showSchoolCountry = function () {
        return self.isFirstLevelOrLongCycle ();
    };

    self.showSchoolCity = function () {
        return self.isFirstLevelOrLongCycle ();
    };

    self.showSchoolName = function () {
        return self.isFirstLevelOrLongCycle ();
    };

    self.showSchoolType = function () {
        return self.isFirstLevelOrLongCycle () && !this.candidate.details.isForeigner;
    };

    self.showUniversityType = function() {
      return !this.candidate.details.isForeigner;
    };

    self.showDiplomaStatus = function() {
      return !self.product.isMba;
    };

    self.showCareer = function() {
      return this.product.isPg || this.product.isMba;
    };

    self.changeSchoolNameDisabled = function() {
      if(self.education.schoolPlace !== '' && self.education.schoolType !== '' && self.education.schoolType !== null) {
        self.state.schoolNameDisabled = false;
      } else {
        self.state.schoolNameDisabled = true;
      }
    };

    self.secondarySchoolCertificateUpdated = function () {
        self.education.schoolCountry = null;
    };

    self.availableOptionalLanguageLevels = function(language) {
        if (language === undefined) {
            return [];
        }

        language = self.data.optionalLanguages[language];

        if (undefined === language) {
            return [];
        }

        return language.available_levels;
    }

    self.availableMandatoryLanguageLevels = function(language) {
        if (undefined === language) {
            return [];
        }

        language = self.data.mandatoryLanguages[language];

        if (undefined === language) {
            return [];
        }

        return language.available_levels;
    }
  }
}

EducationDataCtrl.$inject = ['$scope', '$http', '$compile', 'UtilsService'];

export default EducationDataCtrl;
